module.exports = __webpack_public_path__ + "img/Viber.1499e451.svg";